module.exports = __webpack_public_path__ + "static/media/teeth.702a30f4.svg";